import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { userAPI } from '../../utils/api';
import api from '../../utils/api';
import { DashboardLayout } from '../../components/layout';
import { Spinner, PasswordInput } from '../../components/ui';
import toast from 'react-hot-toast';

const ADMIN_WA = '919443724724';

export default function Profile() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({});
  const [pwd, setPwd] = useState({ current_password:'', new_password:'', confirm_password:'' });
  const [loading, setLoading] = useState(false);
  const [pwdLoading, setPwdLoading] = useState(false);
  const [reqLoading, setReqLoading] = useState(false);
  const [reqDone, setReqDone] = useState(false);
  const [tab, setTab] = useState('info');

  useEffect(() => {
    userAPI.getProfile().then(r => setForm(r.data.user)).catch(() => {});
  }, []);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const save = async () => {
    setLoading(true);
    try {
      await userAPI.updateProfile({ full_name:form.full_name, father_mother_name:form.father_mother_name, date_of_birth:form.date_of_birth, address:form.address, phone:form.phone });
      updateUser({ full_name: form.full_name });
      toast.success('Profile updated!');
    } catch (e) { toast.error(e.response?.data?.message || 'Update failed.'); }
    finally { setLoading(false); }
  };

  const changePwd = async () => {
    if (!pwd.current_password || !pwd.new_password) { toast.error('All fields are required.'); return; }
    if (pwd.new_password !== pwd.confirm_password) { toast.error('Passwords do not match.'); return; }
    if (pwd.new_password.length < 8) { toast.error('Min 8 characters.'); return; }
    setPwdLoading(true);
    try {
      await userAPI.changePassword({ current_password: pwd.current_password, new_password: pwd.new_password });
      toast.success('Password changed!');
      setPwd({ current_password:'', new_password:'', confirm_password:'' });
    } catch (e) { toast.error(e.response?.data?.message || 'Failed.'); }
    finally { setPwdLoading(false); }
  };

  const requestPwdReset = async () => {
    setReqLoading(true);
    try {
      await api.post('/user/password-reset-request');
      setReqDone(true);
      toast.success('Request submitted! Admin will contact you.');
      // Open WhatsApp
      const msg = `Hi, I want to change my TNPSC Hub password.\nRegistered Phone: ${form.phone}\nName: ${form.full_name}\nPlease help me reset my password.`;
      window.open(`https://wa.me/${ADMIN_WA}?text=${encodeURIComponent(msg)}`, '_blank');
    } catch (e) {
      const msg = e.response?.data?.message || e.response?.data?.error || '';
      if (msg.toLowerCase().includes('already')) {
        setReqDone(true);
        toast('Request already submitted. Admin will contact you soon.', { icon: '⚠️' });
      } else {
        toast.error(msg || 'Failed to submit request.');
      }
      // Still open WhatsApp
      const waMsg = `Hi, I want to change my TNPSC Hub password.\nRegistered Phone: ${form.phone}\nName: ${form.full_name}`;
      window.open(`https://wa.me/${ADMIN_WA}?text=${encodeURIComponent(waMsg)}`, '_blank');
    }
    setReqLoading(false);
  };

  return (
    <DashboardLayout title="My Profile" subtitle="Manage your account details">
      <div style={{ maxWidth:700, margin:'0 auto' }}>
        {/* Header card */}
        <div style={{ background:'linear-gradient(135deg,var(--blue-dark),var(--blue))', borderRadius:22, padding:28, marginBottom:22, display:'flex', alignItems:'center', gap:20, position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', width:280, height:280, background:'radial-gradient(circle,rgba(245,166,35,0.13),transparent 70%)', top:-70, right:-50 }} />
          <div style={{ width:72, height:72, borderRadius:'50%', background:'linear-gradient(135deg,var(--gold),var(--gold-dark))', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--font-heading)', fontSize:30, fontWeight:800, color:'var(--blue-dark)', flexShrink:0, position:'relative', boxShadow:'0 6px 20px rgba(245,166,35,0.38)' }}>
            {(form.full_name || 'U')[0].toUpperCase()}
          </div>
          <div style={{ position:'relative' }}>
            <h2 style={{ fontFamily:'var(--font-heading)', fontSize:22, color:'#fff', marginBottom:3 }}>{form.full_name}</h2>
            <p style={{ color:'rgba(255,255,255,0.5)', fontSize:13 }}>{form.email} • {form.phone}</p>
            <div style={{ display:'flex', gap:7, marginTop:9, flexWrap:'wrap' }}>
              <span style={{ background:'rgba(245,166,35,0.18)', border:'1px solid rgba(245,166,35,0.35)', borderRadius:50, padding:'3px 11px', color:'var(--gold)', fontSize:11, fontWeight:600 }}>{form.exam_group}</span>
              <span style={{ background:'rgba(255,255,255,0.09)', border:'1px solid rgba(255,255,255,0.13)', borderRadius:50, padding:'3px 11px', color:'#fff', fontSize:11, fontWeight:600 }}>{form.category}</span>
              <span style={{ background:form.status==='active'?'rgba(40,167,69,0.18)':'rgba(253,126,20,0.18)', border:`1px solid ${form.status==='active'?'rgba(40,167,69,0.35)':'rgba(253,126,20,0.35)'}`, borderRadius:50, padding:'3px 11px', color:form.status==='active'?'#5dcc73':'var(--gold)', fontSize:11, fontWeight:600 }}>
                {form.status==='active'?'✅ Active':'⏳ Pending'}
              </span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display:'flex', gap:4, background:'var(--bg2)', borderRadius:12, padding:4, marginBottom:22 }}>
          {[['info','👤','Personal Info'],['reset','🔐','Request Reset']].map(([v,ic,l]) => (
            <button key={v} onClick={() => setTab(v)} style={{ flex:1, padding:'10px', borderRadius:9, border:'none', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:13, fontWeight:600, transition:'var(--transition)', background:tab===v?'#fff':'transparent', color:tab===v?'var(--blue)':'var(--muted)', boxShadow:tab===v?'var(--shadow-sm)':'none' }}>
              {ic} {l}
            </button>
          ))}
        </div>

        {/* PERSONAL INFO */}
        {tab === 'info' && (
          <div className="card ani-scale">
            <div className="card-header"><h3 style={{ fontSize:17, fontWeight:700 }}>Personal Information</h3></div>
            <div className="card-body">
              <div className="g2">
                {[['full_name','Full Name','👤'],['father_mother_name','Father / Mother Name','👨‍👩‍👦'],['phone','Phone Number','📱']].map(([k,l,ic]) => (
                  <div key={k} className="form-group">
                    <label className="form-label">{l}</label>
                    <div className="input-wrap"><span className="input-icon">{ic}</span>
                      <input className="form-input" value={form[k]||''} onChange={e=>f(k,e.target.value)} />
                    </div>
                  </div>
                ))}
                <div className="form-group">
                  <label className="form-label">Date of Birth</label>
                  <div className="input-wrap"><span className="input-icon">📅</span>
                    <input type="date" className="form-input" value={form.date_of_birth?.split('T')[0]||''} onChange={e=>f('date_of_birth',e.target.value)} />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <div className="input-wrap"><span className="input-icon">📧</span>
                    <input className="form-input" value={form.email||''} disabled style={{ opacity:0.55, cursor:'not-allowed' }} />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Exam Group</label>
                  <div className="input-wrap"><span className="input-icon">🎯</span>
                    <input className="form-input" value={form.exam_group||''} disabled style={{ opacity:0.55, cursor:'not-allowed' }} />
                  </div>
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Address</label>
                  <textarea className="form-textarea" value={form.address||''} onChange={e=>f('address',e.target.value)} />
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
                <button className="btn btn-primary btn-lg" onClick={save} disabled={loading}>
                  {loading ? <><Spinner size={17} color="white" />Saving...</> : '💾 Save Changes'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* CHANGE PASSWORD */}
        {tab === 'pwd' && (
          <div className="card ani-scale">
            <div className="card-header"><h3 style={{ fontSize:17, fontWeight:700 }}>Change Password</h3></div>
            <div className="card-body" style={{ maxWidth:400 }}>
              <PasswordInput label="Current Password" placeholder="Enter current password" value={pwd.current_password} onChange={e=>setPwd(p=>({...p,current_password:e.target.value}))} required />
              <PasswordInput label="New Password" placeholder="Min 8 characters" value={pwd.new_password} onChange={e=>setPwd(p=>({...p,new_password:e.target.value}))} required />
              <PasswordInput label="Confirm New Password" placeholder="Re-enter new password" value={pwd.confirm_password} onChange={e=>setPwd(p=>({...p,confirm_password:e.target.value}))} required />
              <button className="btn btn-primary btn-lg" onClick={changePwd} disabled={pwdLoading}>
                {pwdLoading ? <><Spinner size={17} color="white" />Changing...</> : '🔐 Change Password'}
              </button>
            </div>
          </div>
        )}

        {/* REQUEST PASSWORD RESET */}
        {tab === 'reset' && (
          <div className="card ani-scale">
            <div className="card-header"><h3 style={{ fontSize:17, fontWeight:700 }}>🔐 Request Password Reset</h3></div>
            <div className="card-body">
              <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7, marginTop:0 }}>
                If you forgot your current password or want admin to reset it, click the button below. Your request will be sent to admin and WhatsApp will open automatically.
              </p>

              {/* Flow steps */}
              <div style={{ background:'var(--bg2)', borderRadius:12, padding:16, marginBottom:22 }}>
                <div style={{ fontWeight:700, color:'var(--blue)', marginBottom:10, fontSize:13 }}>What happens next:</div>
                {[
                  ['1','📲 WhatsApp opens with a pre-filled message to admin'],
                  ['2','🔔 Your request is saved in admin dashboard'],
                  ['3','🔐 Admin resets your password'],
                  ['4','📩 Admin sends new password on WhatsApp'],
                  ['5','✅ You login with the new password'],
                ].map(([n,s]) => (
                  <div key={n} style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:8 }}>
                    <div style={{ width:22, height:22, borderRadius:'50%', background:'var(--blue)', color:'#fff', fontSize:11, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:1 }}>{n}</div>
                    <span style={{ fontSize:13, color:'var(--text)' }}>{s}</span>
                  </div>
                ))}
              </div>

              {!reqDone ? (
                <button className="btn btn-primary btn-lg" onClick={requestPwdReset} disabled={reqLoading}
                  style={{ background:'#25D366', border:'none' }}>
                  {reqLoading ? <><Spinner size={17} color="white" />Submitting...</> : '🔐 Request Password Change'}
                </button>
              ) : (
                <div>
                  <div style={{ background:'rgba(37,211,102,0.08)', border:'1px solid rgba(37,211,102,0.25)', borderRadius:12, padding:16, marginBottom:16, fontSize:14, color:'#1a7a4a' }}>
                    <strong>✅ Request submitted!</strong> Admin will contact you on WhatsApp shortly at <strong>{form.phone}</strong>.
                  </div>
                  <button onClick={() => { setReqDone(false); requestPwdReset(); }}
                    style={{ background:'var(--bg2)', color:'var(--blue)', border:'none', borderRadius:10, padding:'10px 20px', fontSize:14, cursor:'pointer', fontWeight:600 }}>
                    🔄 Send Again
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
